<template>
    <div class="chart-line">
        <div class="chart-line-head">
            <div class="title title__small">Trading results</div>
            <div class="time">
                <button 
                    class="time-item title__small" 
                    :class="{ active: timeframe === 'Week' }"
                    @click="changeTimeframe('Week', 7)">{{ tokens.fullScreenDashboard.week }}
                </button>
                <button 
                    class="time-item title__small" 
                    :class="{ active: timeframe === 'Month' }"
                    @click="changeTimeframe('Month', 30)">{{ tokens.fullScreenDashboard.month }}
                </button>
            </div>
        </div>
        <div style="display: grid; height: 100%"> <!-- hack for highchart height -->
            <div class="no-data" v-if="!dashboardData.balance_chart.length">
                <div class="no-data-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                        <path
                            d="M4.00004 24C3.26671 24 2.63893 23.7389 2.11671 23.2167C1.59449 22.6944 1.33337 22.0667 1.33337 21.3333C1.33337 20.6 1.59449 19.9722 2.11671 19.45C2.63893 18.9278 3.26671 18.6667 4.00004 18.6667H4.35004C4.45004 18.6667 4.5556 18.6889 4.66671 18.7333L10.7334 12.6667C10.6889 12.5556 10.6667 12.45 10.6667 12.35V12C10.6667 11.2667 10.9278 10.6389 11.45 10.1167C11.9723 9.59444 12.6 9.33333 13.3334 9.33333C14.0667 9.33333 14.6945 9.59444 15.2167 10.1167C15.7389 10.6389 16 11.2667 16 12C16 12.0444 15.9778 12.2667 15.9334 12.6667L19.3334 16.0667C19.4445 16.0222 19.55 16 19.65 16H20.35C20.45 16 20.5556 16.0222 20.6667 16.0667L25.4 11.3333C25.3556 11.2222 25.3334 11.1167 25.3334 11.0167V10.6667C25.3334 9.93333 25.5945 9.30556 26.1167 8.78333C26.6389 8.26111 27.2667 8 28 8C28.7334 8 29.3612 8.26111 29.8834 8.78333C30.4056 9.30556 30.6667 9.93333 30.6667 10.6667C30.6667 11.4 30.4056 12.0278 29.8834 12.55C29.3612 13.0722 28.7334 13.3333 28 13.3333H27.65C27.55 13.3333 27.4445 13.3111 27.3334 13.2667L22.6 18C22.6445 18.1111 22.6667 18.2167 22.6667 18.3167V18.6667C22.6667 19.4 22.4056 20.0278 21.8834 20.55C21.3612 21.0722 20.7334 21.3333 20 21.3333C19.2667 21.3333 18.6389 21.0722 18.1167 20.55C17.5945 20.0278 17.3334 19.4 17.3334 18.6667V18.3167C17.3334 18.2167 17.3556 18.1111 17.4 18L14 14.6C13.8889 14.6444 13.7834 14.6667 13.6834 14.6667H13.3334C13.2889 14.6667 13.0667 14.6444 12.6667 14.6L6.60004 20.6667C6.64449 20.7778 6.66671 20.8833 6.66671 20.9833V21.3333C6.66671 22.0667 6.4056 22.6944 5.88337 23.2167C5.36115 23.7389 4.73337 24 4.00004 24Z"
                            fill="url(#paint0_linear_967_11532)" />
                        <defs>
                            <linearGradient id="paint0_linear_967_11532" x1="-3.32754" y1="15.2" x2="14.4176"
                                y2="32.3606" gradientUnits="userSpaceOnUse">
                                <stop stop-color="#4A7EFF" />
                                <stop offset="0.486792" stop-color="#61BEDA" />
                                <stop offset="1" stop-color="#404C73" />
                            </linearGradient>
                        </defs>
                    </svg>
                </div>
                <div class="no-data-title title__small">No trading data available</div>
                <div class="no-data-desc body__small">
                    <span>Start trading to see your results here. </span>
                    <span>Your performance metrics will be displayed once data is available.</span>
                </div>
            </div>
            <highcharts v-else :options="chartOptionsLine" ref="lineChart" />
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex'
import { DASHBOARD_BALANCE } from "@/store/actions.type"

export default {
    name: "BaseLineChart",

    mounted() {
        let dashboardBalance = this.dashboardData.balance_chart
        let data = []
        for (let i = 0; i < dashboardBalance.length; i++) {
            data[i] = dashboardBalance[i][1]
        }
        this.chartOptionsLine.series[0].data = data
        this.foundMinMax()
        this.$refs.aspinPieChart?.chart?.reflow()

        /* if (this.aspinDesign) {
            this.chartOptionsLine.plotOptions.series = {
                fillColor: {
                    linearGradient: [0, 0, 50, 300],
                    stops: [
                        [0, '#C28066'],
                        [1, 'rgba(227,202,116,0.7)']
                    ]
                },
            }
            this.chartOptionsLine.series[0].marker.fillColor = '#C28066'
        } */
    },
    data() {
        return {
            chartOptions: {
                responsive: true
            },
            time: 7,
            timeframeData: [],
            timeframe: 'Week',
            chartOptionsLine: {
                title: false,
                credits: false,
                chart: {
                    backgroundColor: 'transparent',
                    type: 'areaspline',
                    margin: 0,
                    height: 300,
                },
                plotOptions: {
                    areaspline: {
                        fillOpacity: 0.5,
                        lineWidth: 1,
                        color: 'var(--System-Primary)',
                        marker: {
                            enabled: true,
                            radius: 2,
                            fillColor: 'var(--System-Primary)'
                        }
                    },
                    series: {
                        linecap: 'square'
                    }
                },
                legend: true,
                xAxis: {
                    labels: {
                        style: {
                            fontSize: '0px'
                        },
                    },
                    gridLineWidth: 0,
                    tickLength: 0,
                    min: 0,
                    categories: []
                },
                yAxis: {
                    title: {
                        text: null,
                    },
                    labels: {
                        style: {
                            fontSize: '0px'
                        },
                    },
                    min: 0,
                    gridLineWidth: 0,
                    tickLength: 0,
                    display: true,
                },
                lineWidth: 1,
                threshold: null,
                // innerSize: '60%',
                enableMouseTracking: true,

                tooltip: {
                    headerFormat: '{point.x}<br>',
                    pointFormat: '<strong>$ {point.y}',
                    shared: true,
                    style: {
                        fontSize: window.innerWidth > 1400 ? ".8vw" : "12px",
                    }
                },
                series: [{
                    name: '$',
                    data: [],
                    marker: {
                        enable: false,
                        states: {
                            hover: {
                                enabled: true
                            }
                        },
                    },
                    fillColor: { 
                        linearGradient: {
                            x1: 0,
                            y1: 0,
                            x2: 0,
                            y2: 1
                        },
                        stops: [
                            [0, 'rgba(91,147,230,0.2)'], 
                            [1, 'rgba(255,255,255,0)']
                        ]
                    },
                }]
            },
        }
    },
    methods: {
        changeTimeframe(timeframe, time) {
            if (this.time !== time) {
                this.time = time
                this.timeframe = timeframe
                this.$store.dispatch(DASHBOARD_BALANCE, this.time * 24)

                this.chartOptionsLine.series[0].data = this.getTimeframeData
                this.foundMinMax()
            }
        },
        foundMinMax() {
            this.chartOptionsLine.yAxis.min = Math.min.apply(null, this.chartOptionsLine.series[0].data)
            this.chartOptionsLine.yAxis.max = Math.max.apply(null, this.chartOptionsLine.series[0].data)
        },
    },
    computed: {
        ...mapGetters(['tokens', 'modals', 'dashboardData']),
        getTimeframeData() {
            let dashboardBalance = this.dashboardData.balance_chart
            let data = []
            for (let i = 0; i < dashboardBalance.length; i++) {
                data[i] = dashboardBalance[i][1]
            }
            return data
        },
    },
    watch: {
        modals: {
            deep: true,
            handler() {
                if (this.modals.fullscreen) {
                    this.$refs.lineChart?.chart?.reflow();
                }
            }
        },
        dashboardData: {
            deep: true,
            handler() {
                let dashboardBalance = this.dashboardData.balance_chart
                let data = []
                for (let i = 0; i < dashboardBalance.length; i++) {
                    data[i] = dashboardBalance[i][1]
                }

                this.chartOptionsLine.series[0].data = data
                this.foundMinMax()
            }
        },
    }
}
</script>

<style scoped>
.chart-line {
    border-radius: 8px;
    border: 1px solid var(--System-OutlineVariant);
}


.chart-line-head {
    display: grid;
    grid-template-columns: repeat(2, auto);
    place-items: center stretch;
    place-content: space-between;
    padding: 12px 16px;
}

.chart-line .title {
    color: var(--System-OnSurfaceVariant);
}

.chart-line .time {
    display: flex;
    align-items: center;
    gap: 8px;
}

.chart-line .time-item {
    padding: 4px 10px;
    border-radius: 4px;
    color: var(--System-OnSurfaceVariant);
    background: var(--Statelayers-onsurfacevariant-opacity12);
    cursor: pointer
}

.chart-line .time-item.active {
    color: var(--System-Primary);
    background: var(--Statelayers-primary-opacity12);
}

.no-data {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    min-height: 300px
}

.no-data-desc {
    display: flex;
    flex-direction: column;
    text-align: center;
}
</style>